import React, { useMemo, ReactElement, useState } from 'react';
import { Modal } from 'antd';
import { Menu } from 'semantic-ui-react';

import { putWelfarePolicy } from 'apis/captainpayment/member';
import Table from 'vcomponents/Table';

import { columns } from './viewMeta';
import { Container } from './styles';
import ChangePolicyMeModal from './modal/ChangePolicyMeModal';

const { success } = Modal;

interface PolicyListProps {
  PolicyFn;
}

function PolicyList(props: PolicyListProps): ReactElement {
  const { PolicyFn } = props;
  const { policy, welfareName, getWelfarePolicy, welfareIdx } = PolicyFn;
  const [visible, setVisible] = useState(false);
  const [melPolicy, setMelPolicy] = useState(false);

  const onClick = (e) => {
    setMelPolicy(e);
    setVisible(true);
  };

  const policyData = useMemo(() => {
    if (policy && policy.length > 0) {
      policy.forEach((row) => (row.onClick = onClick));
      return policy;
    }
    return [];
  }, [policy]);

  const closeModal = () => {
    setVisible(false);
  };

  const showConfirm = () => {
    success({
      content: '복지 정책 변경이 완료되었습니다.'
    });
  };

  const changePolicy = async (idx, params) => {
    await putWelfarePolicy(idx, params);
    await getWelfarePolicy(welfareIdx, welfareName);
    showConfirm();
  };

  const modalFn = useMemo(() => {
    return {
      visible,
      closeModal,
      changePolicy,
      melPolicy,
      welfareName
    };
  }, [visible, melPolicy, welfareName]);

  return (
    <Container>
      <Menu vertical className="vendysLeftMenu group" fluid>
        <Menu.Item className="top" name="title">
          복지정책({welfareName})
        </Menu.Item>
        <Table columns={columns} data={policyData || []} pageInfo={{}} style={{ padding: 0 }} />
      </Menu>
      <ChangePolicyMeModal modalFn={modalFn} />
    </Container>
  );
}

export default PolicyList;
